<div class="cv-cascader cv-cascader-component"
	[attr.tabindex]="indexTab" 
	(keydown.Tab)="hideOptions()" 
	(keyup.Tab)="showOptions()">
	<div class="cv-cascader__input action-toggle" 
		[ngClass]="{ 
			'cv-cascader__input--invalid': !valid, 
			'cv-cascader__input--disable': disabled 
		}" 
		(click)="openOptions()">
		<div class="cv-cascader__input__label">
			{{ __value ? __value : placeholder }}
		</div>
		<div class="cv-cascader__input__arrow">&#9662;</div>
	</div>
	<div class="cv-cascader__options" *ngIf="isOpen">
		<div class="cv-cascader__options__list" *ngFor="let list of options; let listIndex = index;">
			<div *ngFor="let item of list;"
				class="cv-cascader__options__list__item action-select"
				(click)="selectItem(item, listIndex)"
				 [ngClass]="{'active': item.active}">
				<span class="item-value">{{item[configOptions.text]}}</span> &nbsp;&nbsp;&nbsp;
				<span *ngIf="!!item.children" class="cv-cascader__input__arrow has_children">&#9656;</span>
			</div>
		</div>
	</div>
</div>
